import { render } from "./ProductsList.vue?vue&type=template&id=611e430f&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import "./ProductsList.vue?vue&type=style&index=0&id=611e430f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611e430f"]])

export default __exports__